// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"VerifyEmail_buttonWrapper__WGG7t"};